import { useState } from "react";
import { faqItems } from "@/mocks/basetaoData";

export default function FAQSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  return (
    <section className="w-full py-14 md:py-20 bg-background-50" id="faq">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-semibold text-foreground-900 mb-3 text-center">
            Frequently Asked Questions
          </h2>
          <p className="text-sm md:text-base text-foreground-600 text-center mb-10 max-w-xl mx-auto">
            Everything you need to know about BaseTao Spreadsheet resources and how to make the most of them.
          </p>

          <div className="space-y-3">
            {faqItems.map((item, idx) => (
              <div
                key={idx}
                className="rounded-xl border border-background-200/70 bg-background-100 overflow-hidden"
              >
                <button
                  onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                  className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                >
                  <span className="text-sm font-semibold text-foreground-900 pr-4">
                    {item.question}
                  </span>
                  <i
                    className={`ri-${openIdx === idx ? "subtract" : "add"}-line text-lg w-5 h-5 flex items-center justify-center text-foreground-500 flex-shrink-0 transition-transform duration-200`}
                  ></i>
                </button>
                {openIdx === idx && (
                  <div className="px-5 pb-4">
                    <p className="text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}